import React, { FunctionComponent, ReactNode } from 'react'
import { Grid, Heading, Icon, Message, Text } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { usePaymentMessageContext, useSchedulePreviewText, useShowPaymentScheduleTooltip } from '../../state'
import { Trans, useTranslation } from 'next-i18next'
import styles from './style.module.css'

interface Props {
  onToggleSchedule: () => void
  scheduleOpen: boolean
}

export const PaymentScheduleExperimentAccordionButton: FunctionComponent<Props> = ({ onToggleSchedule, scheduleOpen }) => {
  const { sectionHeadingSize, textSize } = useCheckoutSizes()
  const previewText = useSchedulePreviewText()
  const { t } = useTranslation()
  const testNameSpace = 'payment-schedule-experiment'
  const showTooltip = useShowPaymentScheduleTooltip(false)
  const tooltipContext = usePaymentMessageContext()

  const renderTooltip = (): ReactNode => (
    <Text>
      <Trans i18nKey='common:amountDueToday' context={tooltipContext} />
    </Text>
  )

  return (
    <button className={styles.button} onClick={onToggleSchedule} {...{ 'data-testid': `${testNameSpace}-button`, 'aria-expanded': scheduleOpen }}>
      <div className={styles.buttonTitle}>
        <Grid>
          <Heading size={sectionHeadingSize} renderAs='h4' testNameSpace={testNameSpace}>
            {t('summary:scheduleTitle')}
          </Heading>
          <Grid.FixedItem width={108} align='right'>
            <div className={styles.buttonCaret}>
              <Heading size={sectionHeadingSize} renderAs='h4'>
                {t('summary:button')}
              </Heading>
              {scheduleOpen ? <Icon.CaretUp size='ExtraSmall' title='Collapse' role='img' /> : <Icon.CaretDown size='ExtraSmall' title='Expand' role='img' />}
            </div>
          </Grid.FixedItem>
        </Grid>
      </div>
      <Text color='Gray40' size={textSize}>
        {previewText}
      </Text>
      {showTooltip && (
        <div className={styles.autopayTooltipWrapper}>
          <Message kind='Basic' description={renderTooltip()} testNameSpace='recurring-payment' />
        </div>
      )}
    </button>
  )
}
